// src/vocabulary/B1/unit2/content.js

const content = {
  level: "B1",
  unit: 2,
  title: "Around Town & Directions",
  description:
    "Common places around town and words used to ask for and give directions.",

  explanation: [
    "This unit focuses on places in a town or city.",
    "You will learn how to ask for and give directions.",
    "These words are often used with prepositions like 'near', 'next to', and 'across from'.",
    "For example: The bank is next to the supermarket.",
    "You can also use these words to help someone find a place.",
    "Giving directions is an important real-life skill.",
    "In English, directions are usually clear and simple.",
    "Try to imagine helping a tourist find a place in your city."
  ],

  items: [
    {
      word: "bank",
      phonetic: "/bæŋk/",
      meaning: "بنك",
      example: "The bank is next to the supermarket."
    },
    {
      word: "supermarket",
      phonetic: "/ˈsuːpərˌmɑːrkɪt/",
      meaning: "سوبر ماركت",
      example: "I buy food from the supermarket."
    },
    {
      word: "post office",
      phonetic: "/ˈpoʊst ˌɒfɪs/",
      meaning: "مكتب بريد",
      example: "The post office is across from the bank."
    },
    {
      word: "turn left",
      phonetic: "/tɜːrn left/",
      meaning: "انعطف يسارًا",
      example: "Turn left at the traffic lights."
    },
    {
      word: "turn right",
      phonetic: "/tɜːrn raɪt/",
      meaning: "انعطف يمينًا",
      example: "Turn right after the bridge."
    },
    {
      word: "across from",
      phonetic: "/əˈkrɒs frəm/",
      meaning: "مقابل",
      example: "The café is across from the park."
    }
  ]
};

export default content;


